import BasicResource from '@/api/resource';

class CategoriesResource extends BasicResource {
    constructor () {
        super('config/tracking-params');
    }

    retrieve (id) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/config/tracking-params/${id}/enable`,
        });
    }

    delete (id, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/config/tracking-params/${id}/disable`,
            data,
        });
    }
}

export default new CategoriesResource;
